import React from "react";
import "./Loader.css";

export const Loader = () => {
	return (
		<div>
			<span class="loader"></span>
		</div>
	);
};
